import { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Grid } from "@/comn/components";
import { comnUtils } from "@/comn/utils"; // 프로젝트 공통 유틸
import { Page, Group, Layout, Button } from "@/comn/components"; // 화면 구성 컴포넌트
import { useForm, useFetch, useResource, useAuth, useGrid, useStore, useToast, usePage } from "@/comn/hooks"; // hook
import { URLS, APIS, SG_MANL_RCPT_LIST, SF_MANL_RCPT_LIST_SRCH } from "./services/OsciRcptService"; // 서비스
import dayjs from "dayjs";
import { colEnvs, colUtils } from "@/tz/go/egaz/osci/colt/comn";

/*
 * Manual Receipt List
 * !== 수작업 수납 목록 ==!
 */
export const OSCI0402005Q = (props: any) => {
    /*
     * Declaration Hook, Meta
     * !== Hook, 메타 정보 정의 ==!
     */

    useResource({
        defaultSchema: [{ area: "comnCd", comnCd: "OSC0020" }, { area: "coCd" }, { area: "cstmCd" }],
    });

    const { pgeUid } = usePage({
        auth: ["auth_osci0003", "auth_osci0021"],
    }); // Page Unique identifier !== 화면 고유 식별자 ==!
    const navigate = useNavigate(); // Navigate Hook !== 화면 이동 Hook ==!
    const { pgeStore, setStore } = useStore({ pgeUid: pgeUid }); // Page Store Hook !== 화면 데이터 저장 Hook ==!
    const toast = useToast(); // Toast Message Hook !== Toast 메세지 표시 Hook ==!
    const auth = useAuth(); // Login , User Information Hook !== 로그인, 유저정보 Hook ==!

    useResource({
        defaultSchema: [{ area: "comnCd", comnCd: "OSC0096" }],
    });

    /*
     * Declaration Form
     * !== 폼 정의 ==!
     */
    const form = {
        // Manual Receipt Search !== 수작업 수납 검색 ==!
        manlRcptSrch: useForm({
            defaultSchema: SF_MANL_RCPT_LIST_SRCH,
            defaultValues: {
                ...(pgeStore?.form || { aprvStatCd: ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J"] }),
            },
        }),
    };

    /*
     * Declaration Grid
     * !== 그리드 정의 ==!
     */
    const grid = {
        // Manual Receipt List !== 수작업 수납 목록 ==!
        manlRcptList: useGrid({
            defaultSchema: SG_MANL_RCPT_LIST,
            page: pgeStore?.page,
            size: pgeStore?.size,
        }),
    };

    /*
     * Declaration Fetch
     * !== Fetch 정의 ==!
     */
    const fetch = {
        // Get Manual Receipt List !== 수작업 수납 목록 조회 ==!
        getManlRcptList: useFetch({
            api: (page = grid.manlRcptList.page) => {
                let data = {
                    ...form.manlRcptSrch.getValues(),
                    orgCd: auth.get("orgCd"),
                };
                return APIS.getManlRcptList(data, page, grid.manlRcptList.size);
            },
            enabled: comnUtils.isEmpty(form.manlRcptSrch.errors) && form.manlRcptSrch.isSubmitted,
            key: [grid.manlRcptList.page, grid.manlRcptList.size],
            onSuccess: () => {
                setStore(pgeUid, {
                    form: form.manlRcptSrch.getValues(),
                    page: grid.manlRcptList.page,
                    size: grid.manlRcptList.size,
                });
            },
            onError: () => {},
            showToast: true,
        }),
    };

    /*
     * Declaration Event Handler
     * !== 이벤트 핸들러 정의 ==!
     */
    const handler = {
        // Get Manual Receipt List !== 수작업 수납 목록 조회 ==!
        getManlRcptList: (page: number = 0) => {
            form.manlRcptSrch.handleSubmit(
                () => {
                    // Validation Check !== 밸리데이션 체크 ==!
                    grid.manlRcptList.setPage(page);
                    fetch.getManlRcptList.fetch(page);
                },
                () => {
                    toast.showToast({ type: "warning", content: "msg.osc.00003" });
                },
            )();
        },
    };

    const render = {
        grid_manlRcptList: {
            head: {},
            cell: {
                bllNo: (props: any) => {
                    const { rowValues } = props;
                    return (
                        <Layout direction="col" gap={1}>
                            <span style={{ color: "blue" }}>
                                <Link
                                    to={`${URLS.osci0402006q}/${rowValues.bllTpCd}-${rowValues.bllSysmCd}-${rowValues.bllYy}-${rowValues.bllSrno}-${rowValues.bllDgr}-${rowValues.bllRcptSrno}`}
                                >{`${rowValues.bllNo}`}</Link>
                            </span>
                        </Layout>
                    );
                },
                tansadNo: (props: any) => {
                    const { binding, rowValues, value } = props;

                    if (rowValues.reffKeyTpCd == "T") {
                        return (
                            <Layout direction="col" gap={1}>
                                <span style={{ color: "blue" }}>
                                    <Link
                                        to={`${URLS.osci0401003q}/${rowValues.reffKeyNo1}-${rowValues.reffKeyNo2}-${rowValues.reffKeyNo3}/OSCI0402001Q`}
                                    >{`${rowValues.reffKeyNo1}-${rowValues.reffKeyNo2}-${rowValues.reffKeyNo3}`}</Link>
                                </span>
                            </Layout>
                        );
                    } else if (rowValues.tansadNo != null && rowValues.tansadNo.length > 6) {
                        const reffKeyNo1 = rowValues.tansadNo.substring(0, 4);
                        const reffKeyNo2 = rowValues.tansadNo.substring(4, 6);
                        const reffKeyNo3 = rowValues.tansadNo.substring(6);

                        console.log(`${reffKeyNo1}-${reffKeyNo2}-${reffKeyNo3}`);
                        return (
                            <Layout direction="col" gap={1}>
                                <span style={{ color: "blue" }}>
                                    <Link
                                        to={`${URLS.osci0401003q}/${reffKeyNo1}-${reffKeyNo2}-${reffKeyNo3}`}
                                    >{`${reffKeyNo1}-${reffKeyNo2}-${reffKeyNo3}`}</Link>
                                </span>
                            </Layout>
                        );
                    }
                },
            },
            edit: {},
            row: (row: any) => {
                if (row.pyerTpCd == "T") {
                    row.pyerMgmtNo = colUtils.setMask(row.pyerMgmtNo, "tin");
                }
                return true;
            },
        },
    };

    /*
     * Declaration Page Init Function
     * !== 화면 초기화 함수 선언  ==!
     */
    useEffect(() => {
        handler.getManlRcptList(pgeStore?.page);
    }, []);

    return (
        <Page>
            <Group>
                <Group.Body>
                    <Layout direction="row">
                        <Layout.Left size={6}>{}</Layout.Left>
                        <Layout.Right>{}</Layout.Right>
                    </Layout>
                    <Group.Section>
                        <Group.Row>
                            {/* Receipt Custom Office Code !== 고지서 세관 코드 ==!  */}
                            <Group.Control {...form.manlRcptSrch.schema.cstmOfceCd}></Group.Control>
                            {/* TANSAD Number !== TANSAD 번호 ==!  */}
                            <Group.Control {...form.manlRcptSrch.schema.tansadNo}></Group.Control>
                        </Group.Row>
                        <Group.Row>
                            {/* Receipt Registration Date !== 수납 등록 일자 ==!  */}
                            <Group.Control {...form.manlRcptSrch.schema.rcptRgsrDtmRnge}></Group.Control>
                        </Group.Row>
                        <Group.Row>
                            {/* Bill Number !== 고지서 번호 ==!  */}
                            <Group.Control {...form.manlRcptSrch.schema.bllNo}></Group.Control>
                            {/* Payer Menagement Number !== 납부자 관리 번호 ==!  */}
                            <Group.Control {...form.manlRcptSrch.schema.pyerMgmtNo}></Group.Control>
                        </Group.Row>
                        <Group.Row>
                            {/* Approval State Code !== 승인 상태 코드 ==!  */}
                            <Group.Control {...form.manlRcptSrch.schema.aprvPrcssStatCd}></Group.Control>
                        </Group.Row>
                    </Group.Section>

                    <Layout direction="row">
                        <Layout.Left>
                            <Button
                                role="reset"
                                onClick={() => {
                                    form.manlRcptSrch.reset();
                                }}
                            ></Button>
                        </Layout.Left>
                        <Layout.Right>
                            <Button
                                role="search"
                                onClick={() => {
                                    handler.getManlRcptList();
                                }}
                            ></Button>
                        </Layout.Right>
                    </Layout>
                </Group.Body>
            </Group>

            <Group>
                <Group.Body>
                    <Layout direction="row">
                        <Layout.Left>
                            <Button
                                role="excelDown"
                                onClick={() => {
                                    grid.manlRcptList.exportExcel({
                                        /* 다운로드 엑셀 파일명 (확장자 없이), 기본값 Export(년월일시분초) */
                                        excelName: dayjs().format("YYYY-MM-DD HH:mm:ss") + "_" + pgeUid,
                                        /* 다운로드 엑셀 시트명 , 기본값 Sheet */
                                        sheetName: "Sheet Name",
                                    });
                                }}
                            ></Button>
                        </Layout.Left>
                    </Layout>
                    <Grid
                        {...grid.manlRcptList.grid}
                        data={fetch.getManlRcptList.data?.manlRcptList}
                        render={render.grid_manlRcptList}
                    />
                </Group.Body>
            </Group>
            <Layout direction="row">
                <Layout.Left>
                    <Button
                        role="new"
                        onClick={() => {
                            navigate(`${URLS.osci0402007s}/new`);
                        }}
                    ></Button>
                </Layout.Left>
            </Layout>
        </Page>
    );
};
